<div class="collaboration-container">
  <!-- <h1>Quill Editor</h1> -->
  @if (weavyConfigObj) {
    <mat-tab-group class="mat-tab-group-container">
      <mat-tab label="Posts">
        <app-posts [weavyData]="weavyConfigObj.posts"></app-posts>
      </mat-tab>
      <mat-tab label="Referral Documents">
        <app-activity-documents [weavyData]="weavyConfigObj.documents"></app-activity-documents>
      </mat-tab>
      <mat-tab label="Policy Documents">
        <app-policy-documents [weavyData]="weavyConfigObj.policyDocuments"></app-policy-documents>
      </mat-tab>
      <!-- <mat-tab label="Collaboration Summary">
      <app-summary (selectedItem)="selectedItem($event)" [weavyData]="weavyData"></app-summary>
    </mat-tab>
    <mat-tab label="Alerts">
      <app-alerts [weavyData]="weavyData"></app-alerts>
    </mat-tab> -->
  </mat-tab-group>
} @else if(apiFailureOnWeavyData){
  <app-no-required-date></app-no-required-date>
}

<!-- <h1>Summer-note Editor</h1>
<exp-editor></exp-editor> -->
</div>
@if (showLoader) {
  <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
}